// Loads Google Maps JS SDK (Places library) on demand, only once
let promise = null;

export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (promise) return promise;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY manquante"));
  }

  promise = new Promise((resolve, reject) => {
    const cbName = `__bdGoogleMapsCb_${Date.now()}`;
    window[cbName] = () => {
      delete window[cbName];
      if (window.google && window.google.maps && window.google.maps.places) {
        resolve(window.google);
      } else {
        promise = null;
        reject(new Error("Google Maps Places non chargé"));
      }
    };
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey
    )}&libraries=places&language=fr&region=FR&callback=${cbName}&loading=async`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      promise = null;
      delete window[cbName];
      reject(new Error("Échec chargement Google Maps"));
    };
    document.head.appendChild(script);
  });

  return promise;
}
